export const categories = [
  "Information Technology",
  "Healthcare",
  "Finance",
  "Education",
  "Engineering",
  "Manufacturing",
  "Retail",
  "Hospitality",
  "Transportation",
  "Construction",
  "Real Estate",
  "More..."
];

export const categories1 = [
  "Information Technology",
  "Healthcare",
  "Finance",
  "Education",
  "Engineering",
  "Manufacturing",
  "Retail",
  "Hospitality",
  "Transportation",
  "Construction",
  "Real Estate",
  "Telecommunications",
  "Energy",
  "Legal",
  "Marketing and Advertising",
  "Media and Entertainment",
  "Nonprofit",
  "Public Sector",
  "Agriculture",
  "Aerospace",
  "Automotive",
  "Biotechnology",
  "Pharmaceuticals",
  "Consulting",
  "Insurance",
  "Logistics",
  "Food and Beverage",
  "Human Resources",
  "Research and Development",
  "Sales",
  "Supply Chain",
  "Travel and Tourism",
  "Utilities"
];

export const caribbeanCities = [
    // Antigua and Barbuda
    "St. John's",

    // Bahamas
    "Nassau",
    "Freeport",

    // Barbados
    "Bridgetown",

    // Cuba
    "Havana",
    "Santiago de Cuba",
    "Camagüey",
    "Holguín",
    "Santa Clara",
    "Guantánamo",
    "Bayamo",
    "Cienfuegos",
    "Pinar del Río",
    "Matanzas",
    "Ciego de Ávila",
    "Las Tunas",
    "Sancti Spíritus",

    // Dominica
    "Roseau",

    // Dominican Republic
    "Santo Domingo",
    "Santiago de los Caballeros",
    "San Pedro de Macorís",
    "La Romana",
    "San Cristóbal",
    "Puerto Plata",
    "Higüey",
    "La Vega",
    "Bonao",
    "Moca",
    "Nagua",

    // Grenada
    "St. George's",

    // Haiti
    "Port-au-Prince",
    "Cap-Haïtien",
    "Les Cayes",
    "Gonaïves",
    "Jacmel",

    // Jamaica
    "Kingston",
    "Montego Bay",
    "Spanish Town",
    "Portmore",
    "Mandeville",
    "Ocho Rios",
    "Negril",

    // Puerto Rico (U.S. Territory)
    "San Juan",
    "Ponce",
    "Mayagüez",
    "Caguas",
    "Arecibo",
    "Bayamón",
    "Carolina",

    // Saint Kitts and Nevis
    "Basseterre",

    // Saint Lucia
    "Castries",
    "Soufrière",

    // Saint Vincent and the Grenadines
    "Kingstown",

    // Trinidad and Tobago
    "Port of Spain",
    "San Fernando",
    "Chaguanas",
    "Arima",

    // Aruba (Netherlands Territory)
    "Oranjestad",

    // Curaçao (Netherlands Territory)
    "Willemstad",

    // Sint Maarten (Netherlands Territory)
    "Philipsburg",

    // Bonaire (Netherlands Territory)
    "Kralendijk",

    // Guadeloupe (France Territory)
    "Basse-Terre",
    "Pointe-à-Pitre",

    // Martinique (France Territory)
    "Fort-de-France",

    // U.S. Virgin Islands
    "Charlotte Amalie",
    "Christiansted",

    // British Virgin Islands
    "Road Town"
];